import React from 'react';
import { Box } from '@mui/material';
import PromoBannersTable from './../../PromoBannersTable/PromoBannersTable';

const PromoBannersPage = () => {
  return (
    <PromoBannersTable />
  );
};

export default PromoBannersPage;
